import React from 'react';

import {Swiper, SwiperSlide} from 'swiper/react'

import 'swiper/css'
import 'swiper/css/effect-fade'

import { EffectFade, Autoplay } from 'swiper';

import Img1 from '../assets/img/offers/offer1.jpg'
import Img2 from '../assets/img/offers/offer2.jpg'
import Img3 from '../assets/img/offers/offer3.jpg'


const slides = [
  {
    offerTittle: 'Weekend Getaway Package',
    offerDescription: 'Enjoy a relaxing stay with complimentary breakfast and pool access.',
    bg: Img1,
  },
  {
    offerTittle: 'Family Stay Special',
    offerDescription: 'Share a comfortable stay with family-friendly rooms and hotel amenities.',
    bg: Img2,
  },
  {
    offerTittle: 'Wedding Celebration Offer',
    offerDescription: 'Celebrate your special day with our elegant wedding venue and event services.',
    bg: Img3,
  },
];

const OfferSlide = () => {
  return (
    <Swiper 
    modules={[EffectFade,Autoplay]}
    effect={'fade'}
    loop={true}
    autoplay={{
      delay:5000,
      disableOnInteraction: false,
    }}
    className='heroSlider shadow-2xl rounded-3xl'>
      {slides.map((slide, index) => {
        const {offerTittle, offerDescription, bg} = slide;
        return (
            <SwiperSlide className='relative flex justify-center h-[300px] lg:h-[450px] xl:h-[500px]' key={index}>
            <div className='z-20 text-white text-center'>

              <h1 className='text-[30px] font-primary uppercase tracking-[4px] lg:tracking-[5px]
              max-w-[920px] lg:text-[50px] leading-tight mb-10 mt-8 drop-shadow-2xl'>Special Offers
              </h1>

              <h1 className='text-[16px] font-primary uppercase tracking-[2px]
              max-w-[920px] lg:text-[28px] leading-tight mb-6'>{offerTittle}
              </h1>
              <p className='text-[10px] font-primary tracking-[2px]
              max-w-[920px] lg:text-[22px] leading-tight mb-6'>{offerDescription}
              </p>
            </div> 
            <div className='absolute top-0 w-full h-full'>
            <img
              className='object-cover w-full h-full' 
              src={bg} alt=''></img>
            </div>
            <div className='absolute w-full h-full bg-black/50'></div>
          </SwiperSlide>
        )
      })}
    </Swiper>
  )

};

export default OfferSlide;
